import SaveActionPlan from "@/modules/ActionPlan/components/SaveActionPlan/SaveActionPlan.vue";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { QuerySearchFormTemplate } from "@/modules/FormTemplate/models/QuerySearchFormTemplate ";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { SearchContext } from "@/shared/models/SearchContext";
import { Utils } from "@/shared/utils/utils";
import store from "@/store";
import { Http } from "@status/codes";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { CrudChartRenderData } from "../Dashboards/AdminDashboard/models/CrudChartRenderData";
import { ListService } from "../List/services/ListService";
import {
  FORM_TEMPLATES_ACCESS,
  FORM_TEMP_CONSTANTS
} from "./../FormTemplate/constants/FormTemplateConstants";
import { FormTemplateService } from "./../FormTemplate/services/FormTemplateService";
import { TemplatePdfService } from "./../TemplatePdf/services/templatePdfService";
import {
  ACTION_PLAN_ACCESS,
  ACTION_PLAN_CONSTANTS,
  FORM_FILTERS_ACTION_PLAN,
  SEARCH_CONTEXT_DESCRIPTIONS
} from "./constants/ActionPlanConstants";
import { ActionPlanQuery } from "./models/ActionPlanQuery.model";
import {
  ActionPlanChart,
  ActionPlanResponseChart
} from "./models/ActionPlanResponseChart.model";
import { ActionPlanService } from "./services/ActionPlanService";

import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { InfoGroupService } from "./../InfoGroup/services/InfoGroupService";
import {
  ListaSelect,
  ListSelectDetails,
  SourceInfo,
  SourceInfoArray
} from "./models/ActionPlan.model";
import { AxiosError } from "axios";
import { LIST_ACCESS } from "../List/constants/ListConstants";
import { SERVICE_TEMPLATES_ACCESS } from "../ServiceTemplate/constants/ServiceTemplateConstants";
import { INFO_GROUPS_ACCESS } from "../InfoGroup/constants/InfoGroupConstants";
import { TEMPLATE_PDF_ACCESS } from "../TemplatePdf/constants/TemplatePdfConstants";
import { ServiceTemplateHeader } from "../ServiceTemplate/models/ServiceTemplateHeader";

@Component({
  name: "ActionPlan",
  components: { SaveActionPlan, EmptyState, CrudChart },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class ActionPlan extends Vue {
  @Inject() actionPlanService!: ActionPlanService;
  @Inject() listService!: ListService;
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() templatePdfService!: TemplatePdfService;

  TITLE_PAGE = ACTION_PLAN_CONSTANTS.PAGE_TITLE;
  EMPTY_STATE = FORM_MESSAGES.INFO_MESSAGE;
  dataToMainView!: MenuDataStructure;

  querySearch?: ActionPlanQuery = {};
  filterArray: Filter[] = FORM_FILTERS_ACTION_PLAN;
  OPERATIONS: string[] = [];
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  categories: List[] = [];

  listDataArray: SourceInfoArray = {
    formTemplate: [],
    infoGroup: [],
    serviceTemplate: []
  };

  listData: SourceInfo = {
    formTemplate: [],
    infoGroup: [],
    serviceTemplate: [],
    variables: []
  };
  pdfList: ListaSelect[] = [];
  lastRefPdfArray = "";
  notFoundPdfArray = false;

  idActionPlan = "";
  isVisibleSaveActionPlan = false;

  isLoadingCharts = false;
  showCharts = false;
  infoGroupChartData: CrudChartRenderData = CHART_INIT;

  responseData?: ActionPlanResponseChart;

  loadingService = true;
  loadingGroups = true;
  loadingPdfList = true;

  lastServiceTemplateRef = "";
  notFoundServiceTemplate = false;
  lastInfoGroupRef = "";
  notFoundInfoGroup = false;

  mounted() {
    Promise.all([
      this.getCategoryListMultimedia(),
      this.getServiceTable(),
      this.getInfoGroupArray(),
      this.getFormTemplateArray(),
      this.getPdfArray(),
      this.getDataChart()
    ]);
    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.ACTION_PLAN
    );
    this.emitSearchInitializer();
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  async emitSearchInitializer() {
    const searchContext: SearchContext = {
      title: ACTION_PLAN_CONSTANTS.PAGE_TITLE_SEARCH,
      filterArray: this.filterArray,
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.ACTION_PLAN,
      descriptions: SEARCH_CONTEXT_DESCRIPTIONS,
      optionsToFilter: [],
      textButtonCreate: ACTION_PLAN_CONSTANTS.BUTTON.ADD
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  async getCategoryListMultimedia() {
    const responseData = await this.getListDataById(
      ACTION_PLAN_CONSTANTS.CATEGORY_ID
    );
    this.categories = responseData ? responseData : [];
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code !== Http.Found || !responseData.data) {
        Snackbar.popInfo(LACK_OF_OPTIONS);
        return;
      }

      const listDataList: List[] = [];
      const dataList = responseData.data.optionsSchema as {
        title: string;
      }[];
      dataList.forEach(a => listDataList.push({ key: a.title, name: a.title }));
      return listDataList;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  setServicetemplateList(data: ServiceTemplateHeader[]) {
    this.listDataArray.serviceTemplate = data;
    this.listData.serviceTemplate = data.map(serviceTemplate => ({
      key: serviceTemplate.id as string,
      name: serviceTemplate?.name ?? ""
    }));
  }

  async handleServiceTemplates(name: string) {
    this.loadingService = true;
    const responseData = await this.serviceTemplateService.getDataChart({
      internalName: name,
      statesList: [STATE.ACTIVE]
    });
    if (responseData.code == Http.Found && responseData.data) {
      this.setServicetemplateList([
        ...this.listDataArray.serviceTemplate,
        ...responseData.data.serviceTmpArray
      ]);
    }
    this.loadingService = false;
  }

  async getServiceTable(name?: string) {
    try {
      if (this.notFoundServiceTemplate) return;
      if (name) {
        await this.handleServiceTemplates(name);
        return;
      }
      this.loadingService = true;
      let data: ServiceTemplateHeader[] = [];
      const responseData = await this.serviceTemplateService.getDataChart({
        typesList: [ACTION_PLAN_CONSTANTS.QUERY_SEARCH.SECTIONS],
        paginatedResult: false,
        chartData: false,
        docRef: this.lastServiceTemplateRef,
        statesList: [STATE.ACTIVE]
      });

      if (responseData.code !== Http.Found || !responseData.data) {
        this.notFoundServiceTemplate = true;
        this.loadingService = false;
        Snackbar.popInfo(LACK_OF_OPTIONS);
        return;
      }
      if (this.lastServiceTemplateRef) {
        data = [
          ...this.listDataArray.serviceTemplate,
          ...responseData.data.serviceTmpArray
        ];
      } else {
        data = responseData.data.serviceTmpArray;
      }
      this.setServicetemplateList(data);

      this.lastServiceTemplateRef = responseData.data.lastRef || "";
      this.loadingService = false;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async templateSelected(selectedTemplate: ServiceTemplateHeader) {
    const exist = this.listData.serviceTemplate.find(
      item => item.name == selectedTemplate.name
    );
    if (!exist && selectedTemplate?.name) {
      await this.handleServiceTemplates(selectedTemplate?.name);
    }
  }

  setInfoGroupsList(data: ListSelectDetails[]) {
    this.listDataArray.infoGroup = data;
    this.listData.infoGroup = data as ListaSelect[];
  }

  async handleInfoGroups(name: string) {
    this.loadingGroups = true;
    const responseData = await this.infoGroupService.getInfoGroupByFilters({
      name,
      state: STATE.ACTIVE
    });
    if (responseData.code == Http.Found && responseData.data) {
      const tempData = responseData.data.groups.map(infoGroupRef => {
        const newElement: ListSelectDetails = {
          type: "infoGroup",
          key: infoGroupRef._key,
          name: infoGroupRef.name,
          version: infoGroupRef.version,
          fields: infoGroupRef.fields?.map(field => ({
            key: field.key,
            title: field.schema.title,
            type: field.schema.type
          }))
        };
        return newElement;
      });
      this.setInfoGroupsList([...this.listDataArray.infoGroup, ...tempData]);
    }
    this.loadingGroups = false;
  }

  async getInfoGroupArray(name?: string) {
    try {
      if (this.notFoundInfoGroup) return;
      this.loadingGroups = true;
      let data: ListSelectDetails[] = [];
      if (name) {
        await this.handleInfoGroups(name);
        return;
      }
      const responseData = await this.infoGroupService.getInfoGroupByFilters({
        state: STATE.ACTIVE,
        paginatedResult: true,
        docRef: this.lastInfoGroupRef
      });
      if (responseData.code !== Http.Found || !responseData.data) {
        this.notFoundInfoGroup = true;
        this.loadingGroups = false;
        Snackbar.popInfo(LACK_OF_OPTIONS);
        return;
      }

      if (this.lastInfoGroupRef) {
        const tempData = responseData.data.groups.map(infoGroupRef => {
          const newElement: ListSelectDetails = {
            type: ACTION_PLAN_CONSTANTS.QUERY_SEARCH.INFO_GROUP,
            key: infoGroupRef._key,
            name: infoGroupRef.name,
            version: infoGroupRef.version,
            fields: infoGroupRef.fields?.map(field => ({
              key: field.key,
              title: field.schema.title,
              type: field.schema.type
            }))
          };

          return newElement;
        });
        data = [...this.listDataArray.infoGroup, ...tempData];
      } else {
        data = responseData.data.groups.map(infoGroupRef => {
          const newElement: ListSelectDetails = {
            type: ACTION_PLAN_CONSTANTS.QUERY_SEARCH.INFO_GROUP,
            key: infoGroupRef._key,
            name: infoGroupRef.name,
            version: infoGroupRef.version,
            fields: infoGroupRef.fields?.map(field => ({
              key: field.key,
              title: field.schema.title,
              type: field.schema.type
            }))
          };

          return newElement;
        });
      }
      this.setInfoGroupsList(data);
      this.lastInfoGroupRef = responseData.data.docRef || "";
      this.loadingGroups = false;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getFormTemplateArray() {
    try {
      const query: QuerySearchFormTemplate = { state: [STATE.ACTIVE] };
      const responseData = await this.formTemplateService.getFormTemplateWithFiltersArray(
        query
      );

      if (responseData.code !== Http.Found || !responseData.data) {
        Snackbar.popInfo(LACK_OF_OPTIONS);
        return;
      }
      const data = responseData.data.formTemplates;
      this.listDataArray.formTemplate = data.map(formTemplateRef => {
        const newElement: ListSelectDetails = {
          type: "formTemplate",
          key: formTemplateRef._key,
          name: formTemplateRef.name,
          version: formTemplateRef.version,
          fields: formTemplateRef.fields?.map(field => ({
            key: field.key,
            title: field.schema.title,
            type: field.schema.type
          }))
        };

        return newElement;
      });

      this.listData.formTemplate = data.map(formTemplate => ({
        key: formTemplate._key,
        name: formTemplate.name,
        category: formTemplate.category,
        version: formTemplate.version
      }));
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async handlePdf(name: string) {
    this.notFoundPdfArray = false;
    this.loadingPdfList = true;
    const responseData = await this.templatePdfService.getDataInitial({
      name: [name]
    });
    if (responseData.code == Http.Found && responseData.data) {
      this.pdfList = [
        ...this.pdfList,
        ...responseData.data.pdfTemplateList.map(x => ({
          key: x?.id ?? "",
          name: x.name
        }))
      ];
    } else {
      this.notFoundPdfArray = true;
    }
    this.loadingPdfList = false;
  }
  async getPdfArray(name?: string) {
    try {
      if (name) {
        await this.handlePdf(name);
        return;
      }
      if (this.notFoundPdfArray) return;
      this.loadingPdfList = true;
      const query: QuerySearchFormTemplate = {
        type: [ACTION_PLAN_CONSTANTS.QUERY_SEARCH.ACTION_PLAN],
        paginatedResult: true,
        docRef: this.lastRefPdfArray
      };

      const responseData = await this.templatePdfService.getDataInitial(query);

      if (responseData.code !== Http.Found || !responseData.data) {
        this.loadingPdfList = false;
        this.notFoundPdfArray = true;
        Snackbar.popInfo(LACK_OF_OPTIONS);
        return;
      }

      if (this.lastRefPdfArray) {
        this.pdfList = [
          ...this.pdfList,
          ...responseData.data.pdfTemplateList.map(x => ({
            key: x?.id ?? "",
            name: x.name
          }))
        ];
      } else {
        this.pdfList = responseData.data.pdfTemplateList.map(x => ({
          key: x?.id ?? "",
          name: x.name
        }));
      }

      this.lastRefPdfArray = responseData.data.docRef || "";
      this.loadingPdfList = false;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + TEMPLATE_PDF_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editActionPlan(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        await this.deleteActionPlan(itemId);
        this.closeActionPlan();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateActionPlanById(itemId, STATE.ACTIVE);
        this.closeActionPlan();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateActionPlanById(itemId, STATE.INACTIVE);
        this.closeActionPlan();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.closeActionPlan();
        break;
    }
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.getDataChart();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT:
          this.sendDataToLateralMenu(
            PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT
          );
          break;
      }
    }
  }
  showFormActionPlan(val: boolean) {
    this.isVisibleSaveActionPlan = val;
  }

  get currentIcon() {
    return !this.isVisibleSaveActionPlan
      ? GENERAL_CONSTANTS.ICONS.ADD
      : GENERAL_CONSTANTS.ICONS.CANCEL;
  }

  get currentTooltip() {
    return !this.isVisibleSaveActionPlan
      ? ACTION_PLAN_CONSTANTS.BUTTON.ADD
      : ACTION_PLAN_CONSTANTS.BUTTON.CLOSE;
  }

  onButtonAdd() {
    this.addFormRole("", FORM_TEMP_CONSTANTS.CREAR_FORMULARIO);
  }

  addFormRole(id: string, action: string) {
    if (action === FORM_TEMP_CONSTANTS.CREAR_FORMULARIO) {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.showFormActionPlan(true);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
        );
        this.TITLE_PAGE = ACTION_PLAN_CONSTANTS.ADD_PAGE_TITLE;
      } else {
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
      }
      return;
    }
  }

  async closeActionPlan() {
    this.TITLE_PAGE = ACTION_PLAN_CONSTANTS.PAGE_TITLE;
    this.idActionPlan = "";
    this.showFormActionPlan(false);
    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
    );
    await this.getDataChart();
  }

  getFilterQuery(): ActionPlanQuery {
    const filterQuery: ActionPlanQuery = {};
    if (this.querySearch?.state) {
      filterQuery.state = this.querySearch.state;
    }
    if (this.querySearch?.name) {
      filterQuery.name = this.querySearch.name;
    }
    if (this.querySearch?.category) {
      filterQuery.category = this.querySearch.category;
    }
    filterQuery.onGraph = "True";
    return filterQuery;
  }

  updateDataGraph(data: ActionPlanChart) {
    this.infoGroupChartData = {
      chartTitle: ACTION_PLAN_CONSTANTS.GRAPH.TITLE,
      chartRenderData: Utils.mapChartDataByOne(data.category)
    };
    this.showCharts = true;
  }

  async getDataChart() {
    this.isLoadingCharts = true;
    this.showCharts = false;
    try {
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
      );
      const response = await this.actionPlanService.getActionPlanByQuery(
        this.getFilterQuery()
      );
      this.isLoadingCharts = false;
      if (response.code !== Http.Found || !response.data) {
        this.infoGroupChartData = CHART_INIT;
        this.showCharts = false;
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
        if (response.code !== Http.NotFound) {
          throw new Error(response.message);
        }
        Snackbar.popInfo(response.message);
        return;
      }
      this.responseData = response.data;
      this.clickOut();
    } catch (error) {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ACTION_PLAN_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    this.isLoadingCharts = false;
  }

  editActionPlan(idActionPlan: string) {
    this.TITLE_PAGE = ACTION_PLAN_CONSTANTS.EDIT_PAGE_TITLE;
    this.idActionPlan = idActionPlan;
    this.showFormActionPlan(true);
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      idActionPlan
    );
  }

  async updateStateActionPlanById(id: string, state: string) {
    try {
      const responseData = await this.actionPlanService.updateStateActionPlanById(
        id,
        state
      );
      if (responseData.code !== Http.Ok) {
        throw new Error(FORM_MESSAGES.REQUEST_FAILED);
      }
      Snackbar.popSuccess(responseData.message);
      await this.getDataChart();
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ACTION_PLAN_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async deleteActionPlan(id: string) {
    try {
      const responseData = await this.actionPlanService.deleteActionPlan(id);

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(ACTION_PLAN_CONSTANTS.MESSAGES.USED);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ACTION_PLAN_ACCESS.DELETE
        );
      else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  async clickData(label: string) {
    const list = this.responseData?.actionPlanList.filter(
      actionPlan => actionPlan.category.trim() == label
    );
    if (list) {
      await this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        list
      );
      const category: ActionPlanChart = {
        category: {
          [label]: this.responseData?.actionPlanChart?.category[label] ?? 0
        }
      };
      this.updateDataGraph(category);
    }
  }

  async clickOut() {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
      this.responseData?.actionPlanList
    );
    if (this.responseData && this.responseData?.actionPlanChart) {
      this.updateDataGraph(this.responseData.actionPlanChart);
    }
  }
}
